/* RESPONSIBLE TEAM: team-knowledge-foundations */

import EducateArticleListBase from 'embercom/routes/apps/app/articles/articles/list/educate-article-list-base';
import { inject as service } from '@ember/service';

export default class AllArticlesRoute extends EducateArticleListBase {
  @service intl;

  get selectedContentStatus() {
    return '';
  }

  get titleToken() {
    return this.intl.t('articles.shared.left-side-nav.all-articles');
  }

  get title() {
    return this.intl.t('articles.list.all_articles_header_text');
  }

  get contentStatusDefault() {
    return '';
  }

  checkAllRequestDefaults(params, status) {
    if (!params.request) {
      return false;
    }
    return this.checkRequestFilterDefaults(params, status);
  }

  model() {
    let params = this.paramsFor('apps.app.articles');
    let isPresetViewChanged = this.checkAllRequestDefaults(params, this.contentStatusDefault);

    return {
      selectedTagValues: params.selectedTagValues ? params.selectedTagValues.split(',') : [],
      selectedContentStatus: this.selectedContentStatus,
      locale: params.selectedLocaleId || null,
      title: this.title,
      articles: [],
      request: params.request,
      view: params.view,
      isPresetViewChanged,
    };
  }
}
